var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "copy-btn",
      class: { "is-active": _vm.isActive },
      attrs: { "aria-label": _vm.$t(!_vm.isActive ? "Copy" : "Copied") },
      on: { click: _vm.copyText },
    },
    [_c("img", { attrs: { src: require("@/assets/svg/copy.svg"), alt: "" } })]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }